export const FilespaceAccessSourceType = {
    DIRECT: 'direct',
};
